import React from "react";
import "./Help.css";

export const Help = () => {

    return (
        <div className="help main-content p-20" style={{overflow: 'auto'}}>
             <div className="title2">
                IMPORTANT NOTE:
            </div>
            <div className="bold red">
                DPC-8EZ Gen3 must be updated to firmware v1.03 in order to use this editor.
            </div>
            <div className="bold red">
                DPC.micro must be updated to firmware v1.03 in order to use this editor.
            </div>
            <div className="mt-10 line-125">
                Latest firmware, update tools, and info are available on our <a href="https://www.disasterareadesigns.com/support">support page</a>.
            </div>
            <div className="title2">
                How to connect your DPC Pedalboard Controller:
            </div>
            <div className="mt-10 line-125">
            Connect your DPC to your computer using a compatible USB cable
            </div>
            <div className="title2">
                How to use the editor:
            </div>
            <div className="mt-10 line-125">
                After connecting your device, give the app a few seconds to recognize the device and read its configuration.
            </div>
            <div className="mt-20 line-125">
                If the editor displays the version of your device, everything is OK and you can proceed with the configuration.<br />
            </div>
            <div className="mt-5">
                Otherwise :
            </div>
            <ol>
                <li>refresh the editor window in your browser with Cmd-R (Mac) or F5 (Windows.)</li>
                <li>check the MIDI input and MIDI output selection.</li>
                <li>check your cable.</li>
            </ol>
            <div className="mt-20 line-125">
                Each time you modify a parameter, a yellow background will appear to show that the parameter's value has been edited.
                After a few seconds, the new value will be saved in the DPC and the yellow background will disappear.
            </div>
            <div className="mt-5 line-125">
                If a yellow background persists after you have changed a parameter, that means that the editor is unable to write the new value in the DPC.
                In that case please check the MIDI input/output selection, the cable, or refresh the browser window.
            </div>
            <div className="mt-5 line-125">
                Note: you can use the editor without a controller connected. In that case, after you have set up your configuration and your presets, use
                the Export feature to save your configuration in a file. You can re-import this file later on to update your device.
            </div>
           <div className="title2">
                Need help?  Have feedback about the editor?
            </div>
            <div className="mt-10 line-125">
                Please contact us using the <a href="https://www.disasterareadesigns.com/contact">contact page</a>.
            </div>
            <div className="title2">
                Editor Changelog
            </div>
                        <div className="mt-10 line-125">
                * 0.10.10 add zero preset selection for 8EZ, add MIDI channel output assign for 8EZ, requires firmware v1.03
            </div>
            <div className="mt-10 line-125">
                * 0.10.9 initial release, firmware v1.02
            </div>
        </div>
    );
}
